import Rx from 'rxjs';
import { fromJS } from 'immutable';
import { combineEpics } from 'redux-observable';

import { request } from 'core/generalFunctions';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import * as penalizacionesActions from './action';
import { PENALIZACIONES_GET, PENALIZACIONES_SOLUCIONAR } from 'root/actionConstants';

const { ajax } = Rx.Observable;

export const penalizacionesGetEpic = (action$, store) =>
  action$
    .ofType(PENALIZACIONES_GET)
    .throttleTime(1000)
    .switchMap((action) =>
      ajax(request(action))
        .switchMap(({ response }) => {
          if (Array.isArray(response)) {
            let stateToSet = {};
            if (response.length > 0) {
              stateToSet.lista = store.getState().getIn(['penalizaciones', 'lista']).concat(fromJS(response));
              stateToSet.scrollControl = { hasMore: true, cantResults: stateToSet.lista.size, fecha: action.payload.fecha };
            } else stateToSet.scrollControl = { hasMore: false, cantResults: response.length, fecha: new Date() };

            return Rx.Observable.of(penalizacionesActions.setState(stateToSet));
          }
          return Rx.Observable.empty();
        })
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const penalizacionesSolucionarEpic = (action$, store) =>
  action$.ofType(PENALIZACIONES_SOLUCIONAR).switchMap((action) =>
    ajax(request(action))
      .mergeMap(() => {
        let index = null;
        const actionReturn = [];
        let lista = store.getState().getIn(['penalizaciones', 'lista']);
        let penalizacionesUsuario = store.getState().getIn(['penalizaciones', 'penalizacionesUsuario']);

        if (lista.size > 0) {
          lista.find((itm, i) => {
            if (itm && itm.get('id') === action.payload.penalizacionId) {
              lista = lista.delete(i);
              return true;
            }
          });
          actionReturn.push(penalizacionesActions.setState({ lista }));
        }
        if (penalizacionesUsuario.size > 0) {
          penalizacionesUsuario.find((itm, i) => {
            if (itm && itm.get('id') === action.payload.penalizacionId) {
              penalizacionesUsuario = penalizacionesUsuario.delete(i);
              return true;
            }
          });
          actionReturn.push(penalizacionesActions.setState({ penalizacionesUsuario }));
        }
        return actionReturn;
      })
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export default combineEpics(penalizacionesGetEpic, penalizacionesSolucionarEpic);



// WEBPACK FOOTER //
// src/modules/penalizaciones/epics.js